export default {
  allowAlignment: true,
  allowSubheading: false,
  autoCenter: ['initialHeading', 'image', 'button'],
  displaySocialBlocksAsButtons: true
};